/** The ASR callback has already persisted this human message in the dialogue.
 * Reuse it exactly once; a stale/mismatched session must not invent a new turn. */
export function voiceTaskClockMessages<T extends {role:string;content:unknown}>(messages:T[],scope:string,human:{scope:string;content:string}|null):T[]{
 if(!human||human.scope!==scope)return [];
 const last=[...messages].reverse().find(m=>m.role==='user');
 return last?.content===human.content?messages:[];
}
